<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            :start-validations="validations.periodo.date.start"
                            :end-validations="validations.periodo.date.end"
                            :max-date="maxDate"
                            :min-date="minDate"
                            v-model="model.periodo.date"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-time-picker
                            :disabled="!isPeriodoFill"
                            label="Hora de"
                            v-model="model.periodo.time.start"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-time-picker
                            :disabled="!isPeriodoFill"
                            label="Até"
                            v-model="model.periodo.time.end"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="diaSemanaChange()"
                            :options="form.diasSemana"
                            default-option-text="Todos"
                            label="Dia da semana"
                            show-default-option
                            text-field="descricao"
                            v-model="model.diaSemana"
                            value-field="valor"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="tipoAltaChange()"
                            :options="form.tipoAltas"
                            default-option-text="Todos"
                            label="Tipo de alta"
                            show-default-option
                            text-field="descricao"
                            v-model="model.tipoAltaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="5">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="profissionalChange()"
                            :options="form.profissionais"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.profissional"
                            value-field="nome"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="cidChange()"
                            :options="form.cids"
                            default-option-text="Todos"
                            label="CID 10"
                            show-default-option
                            text-field="descricao"
                            v-model="model.cid"
                            value-field="codigo"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="1">
                        <rkm-form-input
                            :disabled="!isPeriodoFill"
                            :validations="validations.idadeDe"
                            @blur="blurIdade()"
                            label="Idade de"
                            type="number"
                            v-model="model.idadeDe"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-input
                            :disabled="!isPeriodoFill"
                            :validations="validations.idadeAte"
                            @blur="blurIdade()"
                            label="Até"
                            type="number"
                            v-model="model.idadeAte"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input-autocomplete
                            :disabled="!isPeriodoFill"
                            :repository="repositories.relatorioAtendimento"
                            :request-query-string-params="getFilter()"
                            :search-fields="[
                                { key: 'integracao_erpsaude_paciente.nome', searchable: true }
                            ]"
                            label="Paciente"
                            v-model="model.paciente"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            :disabled="!isPeriodoFill || model.paciente ? true : false"
                            @blur="blurProntuario()"
                            label="CNS"
                            v-model="model.cns"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="form.sexos"
                            default-option-text="Todos"
                            label="Sexo"
                            show-default-option
                            text-field="descricao"
                            v-model="model.sexoId"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :disabled="!isPeriodoFill"
                            label="Quantidade mínima de atendimentos"
                            v-model="model.quantidade"
                            number
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-0 text-nowrap mt-0">
                        <rkm-button
                            :disabled="!isPeriodoFill"
                            :label="false"
                            @click="handleBuscar()"
                            color="primary"
                            class="mt-0"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="!isPeriodoFill"
                            :label="false"
                            @click="limpar()"
                            class="mt-0"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    no-caret
                    small
                    title="Colunas"
                    cols="1"
                    v-rkm-tooltip.hover
                    menu-class="auto-scroll"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="handleTodosClick"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedColumns"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="imprimir()"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportar()"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                v-if="form"
                :fields="fields"
                :items="items"
                :sort-compare="sortCompare"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                @sort-changed="onSortChanged"
                :tbody-tr-class="rowClass"
                class="table-atendimentos"
            >

                <template v-slot:cell(dataNascimento)="row">
                    {{ row.value ? getFormatedDate(row.value, 'DD/MM/YYYY')  : '' }}
                </template>

                <template #afterTable>
                    <div class="my-2">
                        <p>A linha <span class="blue">azul</span> indica os pacientes com 4 ou mais atendimentos no período.</p>
                    </div>
                </template>
            </rkm-table>
        </rkm-area>

        <ModalPreferenciaImpressao ref="ModalPreferenciaImpressao" @orientation="updateOrientation"/>
    </div>
</template>

<script>
// Components.
import ModalPreferenciaImpressao from '@/components/geral/impressao/Modal'

// Mixins.
import { repository, error, data, object, stringCase, debounce } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Moment.
import moment from 'moment'

// Filters
import formatsFilter from '@/filters/formats'

export default {
    components:{ ModalPreferenciaImpressao },
    computed: {
        minDate() {

            const end = this.model.periodo.date.end
            const dataAtual = moment(this.additionals.dataAtual, 'DD/MM/YYYY')

            if (end != null) {

                return moment(end).subtract(31, 'days').format('DD/MM/YYYY')
            }

            if (this.model.periodo.date.start == null) {

                return null
            }

            return dataAtual.subtract(31, 'days').format('DD/MM/YYYY')
        },
        maxDate() {

            const start = this.model.periodo.date.start
            const dataAtual = moment(this.additionals.dataAtual, 'DD/MM/YYYY')

            if (start != null) {

                const end = moment(start).add(30, 'days')

                if (end.isBefore(dataAtual)) {

                    return end.format('DD/MM/YYYY')
                }
            }

            return dataAtual.format('DD/MM/YYYY')
        },
        fields() {
            return this.columns.filter(column => (column.fixed || false) || this.selectedColumns.includes(column.key))
        },
        optionalColumns() {
            return this.columns.filter(column => !(column.fixed || false))
        },
        validations() {

            let idadeAteMinValue = 0

            if (this.model.idadeDe != null && this.model.idadeDe != '') {

                idadeAteMinValue = this.model.idadeDe
            }

            return {
                periodo: {
                    date: {
                        start: { required: true },
                        end: { required: true },
                    },
                },
                idadeDe: { min: 0, min_value: 0 },
                idadeAte: { min: 0, min_value: idadeAteMinValue},
            }
        },
        isPeriodoFill() {

            return this.model && this.model.periodo.date.start != null && this.model.periodo.date.end != null
        },
    },
    created() {
        this.repositories = {
            relatorioAtendimento: this.getConectaSusRepository('integracao.erpsaude.relatorioAtendimento'),
            impressao: this.getConectaSusRepository('impressao.integracao.erpsaude'),
            export: this.getConectaSusRepository('exportacao.integracao'),
        }

        this.load()
    },
    data: () => ({
        items: [],
        model: null,
        form: null,
        orientation: false,
        additionals: null,
        indeterminate: false,
        filterDefault: {},
        selectedAll: false,
        selectedColumns: [],
        columns: [
            {
                key: 'data',
                label: 'Data',
                class: 'col-min text-center',
                sortable: true,
                filterByFormatted: true,
                fixed: true,
            },
            {
                key: 'horario',
                label: 'Horário',
                class: 'col-min text-center',
                sortable: true,
                filterByFormatted: true,
                fixed: true
            },
            { key: 'diaSemana', label: 'Dia da semana', sortable: true, fixed: false },
            { key: 'nomePaciente', label: 'Paciente', sortable: true, fixed: true },
            { key: 'cns', label: 'CNS', class: 'col-min text-center', sortable: true, fixed: true },
            { key: 'dataNascimento', label: 'Data de nascimento', class: 'col-min text-center', filterByFormatted: true, sortable: true, fixed: true },
            { key: 'idade', label: 'Idade', sortable: true, fixed: false },
            { key: 'sexo', label: 'Sexo', sortable: true, fixed: false },
            { key: 'tipoAlta', label: 'Tipo de alta', sortable: true, fixed: false },
            { key: 'cid', label: 'CID 10', sortable: true, fixed: true },
            { key: 'profissional', label: 'Profissional', sortable: true, fixed: false },
            { key: 'quantidade', label: 'Qtde de atendimentos no período', class: 'col-min text-center', sortable: true, fixed: true },
            { key: 'conectasus', label: 'ConectaSUS', class: 'col-min text-center', sortable: true, fixed: false },
        ],
        selectedCols: [],
        debounceDelay: 400,
        sortBy: 'data',
        sortDesc: false,
    }),
    methods: {
        ...formatsFilter,
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'atendidoEm') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        load() {
            this.setLoading()

            this.repositories.relatorioAtendimento.list()
                .then(({ data }) => {

                    this.model = this.clone(data.model)
                    this.form = this.clone(data.form)
                    this.additionals = this.clone(data.additionals)

                    this.filterDefault = {
                        form: this.clone(this.form),
                        model: this.clone(this.model)
                    }

                    this.addPeriodoWatch()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addPeriodoWatch() {

            this.$watch('model.periodo.date', {
                deep: true,
                handler() {

                    this.model.periodo.time.start = null
                    this.model.periodo.time.end = null
                    this.model.diaSemana = null
                    this.model.tipoAltaId = null
                    this.model.profissional = null
                    this.model.cid = null
                    this.model.paciente = null
                    this.model.sexoId = null
                    this.model.quantidade = null
                    this.model.idadeDe = null
                    this.model.idadeAte = null

                    this.form.diasSemana = []
                    this.form.tipoAltas = []
                    this.form.profissionais = []
                    this.form.status = []
                    this.form.cids = []
                    this.form.sexos = []

                    const filter = this.getFilter()

                    if (filter) {

                        this.setLoading()

                        this.repositories.relatorioAtendimento.list(filter)
                            .then(({ data }) => {

                                this.form = this.clone(data.form);
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
        peridoTimeChange() {

            this.model.diaSemana = null
            this.model.tipoAltaId = null
            this.model.profissional = null
            this.model.cid = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.quantidade = null
            this.model.idadeDe = null
            this.model.idadeAte = null

            this.form.diasSemana = []
            this.form.tipoAltas = []
            this.form.profissionais = []
            this.form.cids = []
            this.form.sexos = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.list(filter)
                    .then(({ data }) => {

                        this.form = this.clone(data.form);
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        diaSemanaChange() {

            this.model.tipoAltaId = null
            this.model.profissional = null
            this.model.cid = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.quantidade = null
            this.model.idadeDe = null
            this.model.idadeAte = null

            this.form.tipoAltas = []
            this.form.profissionais = []
            this.form.cids = []
            this.form.sexos = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorDiaSemana(filter)
                    .then(({ data }) => {

                        this.form.tipoAltas = this.clone(data.tipoAltas)
                        this.form.profissionais = this.clone(data.profissionais)
                        this.form.cids = this.clone(data.cids)
                        this.form.sexos = this.clone(data.sexos)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        tipoAltaChange() {

            this.model.profissional = null
            this.model.cid = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.quantidade = null
            this.model.idadeDe = null
            this.model.idadeAte = null

            this.form.profissionais = []
            this.form.cids = []
            this.form.sexos = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorTipoAlta(filter)
                    .then(({ data }) => {

                        this.form.profissionais = this.clone(data.profissionais)
                        this.form.cids = this.clone(data.cids)
                        this.form.sexos = this.clone(data.sexos)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        profissionalChange() {

            this.model.status = null
            this.model.cid = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.quantidade = null
            this.model.idadeDe = null
            this.model.idadeAte = null

            this.form.cids = []
            this.form.sexos = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorProfissional(filter)
                    .then(({ data }) => {

                        this.form.cids = this.clone(data.cids)
                        this.form.sexos = this.clone(data.sexos)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        statusChange() {

            this.model.cid = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.quantidade = null
            this.model.idadeDe = null
            this.model.idadeAte = null

            this.form.cids = []
            this.form.sexos = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorStatus(filter)
                    .then(({ data }) => {

                        this.form.cids = this.clone(data.cids)
                        this.form.sexos = this.clone(data.sexos)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        cidChange() {

            this.model.idadeDe = null
            this.model.idadeAte = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.quantidade = null

            this.form.sexos = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorCid(filter)
                    .then(({ data }) => {

                        this.form.sexos = this.clone(data.sexos)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        blurIdade() {

            this.model.paciente = null
            this.model.paciente_id = null
            this.model.sexoId = null
            this.model.quantidade = null

            this.form.sexos = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorCid(filter)
                    .then(({ data }) => {

                        this.form.sexos = this.clone(data.sexos)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        onSortChanged(context) {

            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        handleBuscar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.items = []

                    this.repositories.relatorioAtendimento.index(this.getFilter())
                        .then(({ data }) => {

                            this.items = data.atendimentos
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        imprimir() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.$refs.ModalPreferenciaImpressao.open();
                    this.$refs.ModalPreferenciaImpressao.$once('completed', () => {

                        this.setLoading()

                        const filter = this.getFilterExportPrint()

                        this.repositories.impressao.relatorioAtendimento(filter)
                            .then(response => {

                                this.download(response)
                            })
                            .finally(() => this.unsetLoading())
                    })
                })
        },
        exportar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const filter = this.getFilterExportPrint()

                    this.repositories.export.relatorioAtendimento(filter)
                        .then(response => {

                            this.download(response)
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        updateOrientation(value) {
            this.orientation = value;
        },
        getFilterExportPrint() {

            const filter = this.getFilter()
            const $this = this

            const cols = this.fields.map(field => ({
                ...field,
                key: $this.camelToSnake(field.key)
            }));

            filter.columns = cols
            filter.orientation = this.orientation

            const diaSemana = this.form.diasSemana.find(f => f.valor === this.model.diaSemana)
            filter.diaSemanaFilter = diaSemana ? diaSemana.descricao : 'Todos'

            const tipoAlta = this.form.tipoAltas.find(f => f.id === this.model.tipoAltaId)
            filter.tipoAltaFilter = tipoAlta ? tipoAlta.descricao : 'Todos'

            const profissional = this.form.profissionais.find(f => f.nome === this.model.profissional)
            filter.profissionalFilter = profissional ? profissional.nome : 'Todos'

            const cid = this.form.cids.find(f => f.codigo === this.model.cid)
            filter.cidFilter = cid ? cid.descricao : 'Todos'

            filter.pacienteFilter = this.model.paciente ? this.model.paciente.nome : 'Todos'

            const sexo = this.form.sexos.find(f => f.value === this.model.sexoId)
            filter.sexoFilter = sexo ? sexo.descricao : 'Todos'

            return filter
        },
        getFilter() {

            if (this.isPeriodoFill) {

                const filter = this.clone(this.model)

                filter.sortBy = this.sortBy ? this.camelToSnake(this.sortBy) : null
                filter.sortDesc = this.sortDesc
                filter.pacienteId = filter.paciente && filter.paciente.id
                filter.periodo.date.start = this.getFormatedDate(filter.periodo.date.start, 'DD/MM/YYYY')
                filter.periodo.date.end = this.getFormatedDate(filter.periodo.date.end, 'DD/MM/YYYY')

                return this.camelObjectKeysToSnakeRecursive(filter)
            }

            return null
        },
        download(response) {

            const content = new Blob([response.data], {type: response.headers['content-type']})
            const url = URL.createObjectURL(content)
            const link = document.createElement('a')

            link.href = url
            link.target = '_blank'
            link.click()
            link.remove()
        },
        limpar() {

            this.form = this.clone(this.filterDefault.form)
            this.model = this.clone(this.filterDefault.model)
            this.$refs.RkmForm.resetValidator()
        },
        handleTodosClick(selected) {
            this.selectedColumns = selected ? this.optionalColumns.map(c => c.key) : []
        },
        rowClass(item, type) {

            if (type === 'row' && item && item.quantidade >= 4) {

                return 'table-primary'
            }
        }
    },
    mixins: [ repository, error, data, object, stringCase, debounce ],
    watch: {
        selectedColumns(value) {
            this.indeterminate = value.length > 0 && value.length != this.optionalColumns.length
            this.selectedAll = value.length > 0 && value.length == this.optionalColumns.length
        },
        'model.paciente' : function () {

            this.model.cns = this.model.paciente ? this.model.paciente.cns : null
            this.model.sexoId = null
            this.form.sexos = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.list(filter)
                    .then(({ data }) => {

                        this.form = this.clone(data.form);

                        this.form.sexos = this.clone(data.form.sexos)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        'model.periodo.time.start': function (newValue) {
            if (newValue) {
                this.peridoTimeChange()
            }
        },
        'model.periodo.time.end': function (newValue) {
            if (newValue) {
                this.peridoTimeChange()
            }
        },
    }
}
</script>

<style scoped>
    .total {
        text-align: right;
        font-weight: bold;
    }

    .dropdown >>> .auto-scroll {
        max-height: 400px;
        overflow-y: auto;
        width: 400px;
    }

    .border-bottom {
        border-bottom: 1px solid rgb(27, 11, 11);
    }
    .table-atendimentos >>> .blue { color: blue; }
</style>